import type { JSX } from "solid-js";
export function EmptyState(props: { title: string; note: string | JSX.Element }) {
  return (
    <div class="grid h-full place-items-center p-10">
      <div class="max-w-md text-center">
        <div class="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full border border-brand/40 bg-brand/10 text-brand">
          ◌
        </div>
        <h2 class="text-lg font-semibold text-white">{props.title}</h2>
        <p class="mt-1 text-sm text-ink-700">{props.note}</p>
      </div>
    </div>
  );
}
